export default __webpack_public_path__ + "static/media/triber-medium1.0a686051.jpg";